import { module as BaseModule } from 'modujs'

export default class extends BaseModule {
  init () {
    const connection =
      navigator.connection ||
      navigator.mozConnection ||
      navigator.webkitConnection

    if (connection && connection.effectiveType !== '4g') return

    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0.8
    }

    const callback = entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.play()
        } else {
          entry.target.pause()
        }
      })
    }

    const observer = new IntersectionObserver(callback, options)
    const videos = this.el.querySelectorAll('video')

    videos.forEach(vide => {
      observer.observe(vide)
    })
  }
}
